import { useEffect, useState } from 'react';
import axios from 'axios';

let cache = null;
let inflight = null;
const listeners = new Set();

export const refreshSeasonal = () => {
  inflight = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/seasonal`)
    .then(({ data }) => { cache = data; listeners.forEach(fn => fn(data)); return data; })
    .catch(() => cache)
    .finally(() => { inflight = null; });
  return inflight;
};

export const useSeasonal = () => {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    if (!cache && !inflight) refreshSeasonal();
    return () => { listeners.delete(setData); };
  }, []);
  return data;
};

export const isSeasonOn = (s) => !!s?.theme && s.theme !== 'none';
